// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimForApproval from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval';
import SpaModalBody from './modal-body';
import SpaModalHeader from './modal-header';
import TcsmApproveDenyModal from '../../../wip/state/tcsm-approve-deny-modal';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const SpaModal = props =>
    <section className='spa-claim-modal'>
        <WarrantyMediumModal isOpen={props.spaCommentsModal.isVisible}>
            <SpaModalHeader
                actionToTake={props.spaCommentsModal.actionToTake}
                onClose={props.onClose}
                onConfirmation={props.onConfirmation}
            />
            <SpaModalBody
                claimForApproval={props.claimForApproval}
            />
        </WarrantyMediumModal>
    </section>;

SpaModal.displayName = 'SpaModal';
SpaModal.propTypes = {
    claimForApproval: PropTypes.instanceOf(ClaimForApproval).isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    spaCommentsModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired
};

export default SpaModal;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/modal/index.js